<template>
    <!-- <div class="product-alternative">
        <h2>Product Alternativ</h2>
        <h4> 
            <span>{{ productAlternative.name }}</span> {{productAlternative.description}}
        </h4>  -->
       
            
        <div class="productImage" v-if="productAlternative.productImageUrl"> 
            <a :href="`${basedir}/${productAlternative.productPageLink}`">
                <v-lazy-image 
                    :alt="productAlternative.name" 
                    :src-placeholder="`${productAlternative.productImageUrl}?w=${imageSize}`" 
                    :srcset="imageSet.set" 
                    :src="productAlternative.productImageUrl ? `${newImageUrl}?w=${imageSize}` : productAlternative.productImageUrl+'?w='+imageSize"
                    :size="imageSet.size"
                    @error="handleImageError" 
                />            
            </a>
        </div>      
    
</template>

<script>
import VLazyImage from "v-lazy-image";
import * as Bowser from "bowser";
import { default as fetchImage } from '../../../globalComponents/fetchImageUrl';

const fallBackBrowserVersions = {
    Chrome: 31,
    Edge: 17,
    Safari: 15.6,
    Firefox: 64,
    Opera: 18,
    AndriodBrowser: 4.1,
    KaiOSBrowser: 2.5
};

export default {
    name: 'ProductAlternative',
    components: { VLazyImage },
    props: {
        productAlternative: Object
    },
    data() {
        return {
            loading: true,
            imageSize: 181,
            newImageUrl: "",
            imageSrcSets: [1, 1.3, 1.6, 2, 2.5, 2.8],
        }
    },
    computed: {
        isBrowserCompatableForWebPImages() {
            return Number(Bowser.version) > fallBackBrowserVersions[Bowser.name] ? "webp" : "png";
        },
        imageSet() {
            var mode = 'x' //w, x
            var returnObj = {}
            var sizeAttr = [];
            var srcString = '';
            this.imageSrcSets.forEach((size, index) => {
                switch (mode) {
                    case 'x':
                        srcString += this.newImageUrl + '?w=' + Math.floor(this.imageSize * size) + ' ' + size + 'x' + ((index + 1) == this.imageSrcSets.length ? '' : ', ')
                        return {
                            set: srcString,
                            size: ''
                        };
                        break;
                    case 'w':
                        srcString += this.newImageUrl + '?w=' + Math.floor(this.imageSize * size) + ' ' + Math.floor(this.imageSize * size) + 'w' + ((index + 1) == this.imageSrcSets.length ? '' : ', ')
                        sizeAttr.push(Math.floor(this.imageSize * size))
                        break;
                }
            })
            returnObj["set"] = srcString;
            if (mode == 'w') {
                returnObj["size"] = sizeAttr;
            } else {
                returnObj["size"] = '';
            }
            return returnObj
        },
        basedir() {
            return window.basedir;
        }
    },
    async created() {
        await this.setNewImageUrl(this.productAlternative);
    },
    watch: {
        productAlternative: function(newProduct, oldProduct) {
            if(newProduct.productImageUrl !== oldProduct.productImageUrl) {
                this.setNewImageUrl(newProduct);
            }
        }
    },
    methods: {
        async setNewImageUrl(product) {
            try {
                this.loading = true;
                this.newImageUrl = await this.getImageUrl(product);
            } catch (error) {
                console.error('Error setting image URL:', error);
                this.newImageUrl = product.productImageUrl;
            } finally {
                this.loading = false;
            }
        },
        handleImageError() {
            this.newImageUrl = this.productAlternative.productImageUrl;
        },
        async getImageUrl(product) {
            const imageParams = {
                url: product.productImageUrl,
                flap: this.$root.flaptype || "",
                fileExtension: this.isBrowserCompatableForWebPImages,
                size: "",
            };

            try {
                return await fetchImage(imageParams);
            } catch (error) {
                console.error("Error fetching image:", error);
                return product.productImageUrl;
            }
        }
    }
}
</script>

<style scoped lang="scss">
.productImage {  
    
    width: 181px;
    min-height:101px;
    
    img{
        width: 181px;
    }
    
    
}
</style>